import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { RefinementBar as BaseRefinementBar } from '@atlassian/jira-directory-base-v3/src/ui/refinement-bar/index.tsx';
import type { RefinementBar$key } from '@atlassian/jira-relay/src/__generated__/RefinementBar.graphql';
import { FilterItem } from '@atlassian/jira-common-directory-v2/src/components/filter-bar/FilterItem.tsx';
import { FilterBar } from '@atlassian/jira-common-directory-v2/src/components/filter-bar/FilterBar.tsx';
import { ProjectCategoryPicker } from './project-category-picker/ProjectCategoryPicker.tsx';
import { ProjectTypePicker } from './project-type-picker/ProjectTypePicker.tsx';
import { SearchControl } from './search-control/index.tsx';

type Props = {
	dataRef: RefinementBar$key;
};

const Filters = ({ dataRef }: Props) => {
	const data = useFragment(
		graphql`
			fragment RefinementBar on Query @argumentDefinitions(isAnonymous: { type: "Boolean!" }) {
				jira @optIn(to: "JiraProjectTypes") {
					allJiraProjectCategories(cloudId: $cloudId) @skip(if: $isAnonymous) {
						edges {
							__typename
						}
					}
					...ProjectCategoryPicker @skip(if: $isAnonymous)
					...ProjectTypePicker
				}
			}
		`,
		dataRef,
	);

	const shouldShowCategories =
		data.jira && Boolean(data.jira?.allJiraProjectCategories?.edges?.length);

	return (
		<FilterBar>
			<FilterItem expandOnSmall>
				<SearchControl />
			</FilterItem>
			{data?.jira && (
				<FilterItem>
					<ProjectTypePicker dataRef={data.jira} />
				</FilterItem>
			)}
			{shouldShowCategories && (
				<FilterItem>
					<ProjectCategoryPicker dataRef={data.jira} />
				</FilterItem>
			)}
		</FilterBar>
	);
};

export const RefinementBar = ({ dataRef }: Props): React.JSX.Element => (
	<BaseRefinementBar>
		<Filters dataRef={dataRef} />
	</BaseRefinementBar>
);
